import React from 'react';
import { Redirect, Route } from 'react-router-dom';


const Privateroute = ({ component: Component, ...rest }) => {

    
    return (
        <Route
            {...rest}
            render={props =>
                localStorage.getItem("bearer_cogen_token") && localStorage.getItem("admin_lim_cogen_id") ? (
                    <Component {...props} />
                ) : (
                        <Redirect to="/login" />
                    )

            }


        />
    )
}
export default Privateroute
